var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStates500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 429 369.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#Degradado_sin_nombre_1430);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:#fff;}.cls-17{fill:url(#linear-gradient-15);}.cls-18{fill:url(#linear-gradient-16);}.cls-19{fill:#acd0ff;}.cls-20{fill:url(#linear-gradient-17);}.cls-21{fill:url(#linear-gradient-18);}.cls-22{fill:#6eacff;}.cls-23{fill:url(#linear-gradient-19);}.cls-24{fill:url(#linear-gradient-20);}.cls-25{fill:url(#Degradado_sin_nombre_438);}.cls-26{fill:url(#Degradado_sin_nombre_1430-2);}.cls-27{fill:url(#linear-gradient-21);}.cls-28{font-size:73.5px;fill:#ecf4ff;font-family:ProximaNova-Medium, Proxima Nova;font-weight:500;letter-spacing:-0.02em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 194.03,
    x2: 429,
    y2: 194.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71aeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8fbfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b1d2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 294.65,
    y1: 323.66,
    x2: 416.6,
    y2: 332.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 28.66,
    y1: 282.85,
    x2: 170.27,
    y2: 352.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_1430",
    cx: 0.29,
    cy: 329.45,
    r: 102.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#71aeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#8fbfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#b1d2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0,
    y1: 51.97,
    x2: 429,
    y2: 51.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 75.16,
    y1: 59.13,
    x2: 139.04,
    y2: 41.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0,
    y1: 51.91,
    x2: 429,
    y2: 51.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 44.44,
    y1: -289.64,
    x2: 44.44,
    y2: 149.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 394.4,
    y1: 258.83,
    x2: 425.54,
    y2: 258.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 329.32,
    y1: 320.28,
    x2: 381.23,
    y2: 372.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 216.13,
    y1: 355.21,
    x2: 216.78,
    y2: 272.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#deecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7d6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 90.71,
    y1: 294.29,
    x2: 187.71,
    y2: 294.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7d6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deecff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 216.33,
    y1: 349.61,
    x2: 216.33,
    y2: 368.23,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 216.33,
    y1: 354.78,
    x2: 216.33,
    y2: 386.54,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 216.33,
    y1: -156.31,
    x2: 216.33,
    y2: 276.79,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 121.9,
    y1: 120.17,
    x2: 174.16,
    y2: 120.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 191.13,
    y1: 67.7,
    x2: 163.03,
    y2: 95.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 5345.35,
    y1: -1756.61,
    x2: 5464.59,
    y2: -1875.86,
    gradientTransform: "matrix(-1, -0.06, -0.06, 1, 5493.8, 2305.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1eeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#c2dcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#a2caff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95c2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 111.21,
    y1: 168.86,
    x2: 111.21,
    y2: 136.57,
    gradientTransform: "translate(106.31 47.73) rotate(-1.64)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 290.8,
    y1: 67.28,
    x2: 216.78,
    y2: -6.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfdaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#acd0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 273.07,
    y1: 85.01,
    x2: 199.05,
    y2: 11,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_438",
    x1: 121.9,
    y1: 222.48,
    x2: 194.26,
    y2: 222.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71aeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#7db5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#d3e6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f9ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Degradado_sin_nombre_1430-2",
    cx: 11.19,
    cy: 325.78,
    r: 88.6,
    xlinkHref: "#Degradado_sin_nombre_1430"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -30.89,
    y1: 116.95,
    x2: 116.77,
    y2: 184.73,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 32.5,
    width: 429,
    height: 323.07,
    rx: 32.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M429,301.11c-13,43.63-52.38,20.44-92.19,9.8-45.67-12.22-64.54,20.21-64.54,20.21s-18.4,9.3,24,24.45H396.94A32.06,32.06,0,0,0,429,323.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.06,355.57H310.87c-37.71-56.9-142.45,0-170.39-28.3S37.77,263.79,0,272.36v51.15A32.06,32.06,0,0,0,32.06,355.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.3,355.57A40.1,40.1,0,0,0,0,308.35v15.16a32.06,32.06,0,0,0,32.06,32.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M86.26,71.32q3.75.11,7.58.11c56.07,0,102.36-17,109.36-38.93H76.42A98.44,98.44,0,0,1,86.26,71.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.26,71.32q3.75.11,7.58.11c56.07,0,102.36-17,109.36-38.93H76.42A98.44,98.44,0,0,1,86.26,71.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.06,32.5A32.07,32.07,0,0,0,2.62,51.85c18.52,11,48.87,18.52,83.64,19.47A98.44,98.44,0,0,0,76.42,32.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.06,32.5A32.07,32.07,0,0,0,2.62,51.85c18.52,11,48.87,18.52,83.64,19.47A98.44,98.44,0,0,0,76.42,32.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M429,323.51V162.1h0c-42.63-.22-27.77,92.64-20.17,128.23,4.36,20.45-1.43,48.57-20.13,65.24h8.24A32.06,32.06,0,0,0,429,323.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M350.35,297c-45.94,13.06-53,46-92.62,58.53H396.94A32.06,32.06,0,0,0,429,323.51V313.19C411.71,293.85,381.58,288.16,350.35,297Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M187,303.57c0,16.42.1,51.81.1,51.81h58.48V303.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M83.25,283.34V289a16.26,16.26,0,0,0,16.26,16.26H333.15A16.26,16.26,0,0,0,349.42,289v-5.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "258.61 352.81 174.05 352.81 167.16 360.47 265.51 360.47 258.61 352.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 167.15,
    y: 360.47,
    width: 98.36,
    height: 9.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M333.15,126.38H99.51a16.26,16.26,0,0,0-16.26,16.26v140.7H349.42V142.64A16.26,16.26,0,0,0,333.15,126.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M226,296.85H206.71a2.59,2.59,0,1,1,0-5.18H226a2.59,2.59,0,0,1,0,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M311.54,114.57H151.13v11.19H318.56v-4.18A7,7,0,0,0,311.54,114.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M123.39,114.57c-4.59,0-8.32,3.14-8.32,7v4.18h42.72V114.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 129.33,
    cy: 120.17,
    r: 3.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M143.54,117.12a3,3,0,1,0,3,3A3,3,0,0,0,143.54,117.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "115.08 277.65 157.79 277.62 157.79 125.77 115.08 125.77 115.08 277.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "157.79 125.77 157.79 277.62 216.79 277.58 318.56 277.5 318.56 125.77 216.79 125.77 157.79 125.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M147.17,270.88H125.69a1.46,1.46,0,0,0,0,2.92h21.48a1.46,1.46,0,1,0,0-2.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 122.26,
    y: 133.75,
    width: 28.35,
    height: 28.35,
    rx: 4.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M125.24,168.44h-3a1.46,1.46,0,1,0,0,2.92h3a1.46,1.46,0,0,0,0-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M150.61,168.44H129.13a1.46,1.46,0,1,0,0,2.92h21.48a1.46,1.46,0,0,0,0-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M150.61,175.62H143a1.46,1.46,0,0,0,0,2.92h7.66a1.46,1.46,0,0,0,0-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M138.66,175.62h-16.4a1.46,1.46,0,0,0,0,2.92h16.4a1.46,1.46,0,0,0,0-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M150.61,182.8H136.43a1.46,1.46,0,0,0,0,2.92h14.18a1.46,1.46,0,1,0,0-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M131.86,182.8h-9.6a1.46,1.46,0,1,0,0,2.92h9.6a1.46,1.46,0,0,0,0-2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M217.82,233.45c12.24,0,17.78,11.08,17.78,22.16s-5.54,22.23-17.78,22.23S200,266.69,200,255.61,205.51,233.45,217.82,233.45Zm0,8.11c-6.19,0-8.51,6.13-8.51,14.05s2.32,14.11,8.51,14.11,8.44-6.19,8.44-14.11S223.94,241.56,217.82,241.56Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 221.58,
    cy: 178.54,
    r: 66.56,
    transform: "translate(-61.35 208.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M256.47,233.45c12.24,0,17.78,11.08,17.78,22.16s-5.54,22.23-17.78,22.23-17.78-11.15-17.78-22.23S244.17,233.45,256.47,233.45Zm0,8.11c-6.18,0-8.5,6.13-8.5,14.05s2.32,14.11,8.5,14.11,8.44-6.19,8.44-14.11S262.59,241.56,256.47,241.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M168.14,265.21a15.7,15.7,0,0,0,11.47,4.64c5.09,0,8-2.9,8-6.44,0-3.93-2.83-6.58-7.73-6.58a12.38,12.38,0,0,0-9,3.55l-6.38-1.74V234.09H194V242H173.43v10.76a14.81,14.81,0,0,1,9.66-3.61A13.44,13.44,0,0,1,196.88,263c0,9.08-6.83,14.82-17.21,14.82-7.47,0-12.88-2.45-16.55-6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M222.18,168.42A169.05,169.05,0,0,0,166.07,178s24.41,30,54.91,30.33,55.55-29.15,55.55-29.15A154.47,154.47,0,0,0,222.18,168.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M194.58,170.66a27.87,27.87,0,1,0,53.55.36,150.91,150.91,0,0,0-25.95-2.6A157.93,157.93,0,0,0,194.58,170.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M243.56,171.48a1.35,1.35,0,0,1,1.66,1,23.66,23.66,0,0,1,.77,4.75,1.36,1.36,0,0,1-1.28,1.43,1.4,1.4,0,0,1-.36,0,1.37,1.37,0,0,1-1.08-1.26,21.26,21.26,0,0,0-.67-4.2A1.35,1.35,0,0,1,243.56,171.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M222.18,168.42c-2.42,0-4.8,0-7.15.11A11.8,11.8,0,1,0,232.86,176a6.73,6.73,0,0,1-2.3.38A6.64,6.64,0,0,1,224,169.7a7.24,7.24,0,0,1,.14-1.24C223.47,168.44,222.83,168.42,222.18,168.42Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 194.45,
    width: 145.69,
    height: 87.56,
    rx: 43.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M271.63,82.74c1.18.89,5.84,4.55,6.4,10.46.69,7.36-5.52,12.19-6.4,12.86a50.61,50.61,0,0,0,16.69-9.37,38.28,38.28,0,0,0,8.53-10.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M187.78,226.31c0-4.3-7.78-15.45-7.78-15.45s-7.79,11.15-7.79,15.45a7.79,7.79,0,0,0,15.57,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 37.95,
    cy: 324.26,
    r: 27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M86.41,76.81c0-1.84-.06-3.67-.15-5.49A98.44,98.44,0,0,0,76.42,32.5H32.06A32,32,0,0,0,0,64.56V264.84C46.49,266.44,33.47,222,29.19,198c-4.44-24.95,34.55-46,47.91-78.24l.09-.21h0A100.18,100.18,0,0,0,86.41,76.81Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-28",
    transform: "translate(242.45 68.61)"
  }, "!?"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStates500);
export default __webpack_public_path__ + "static/media/EMPTY_STATES_500.f127d0524b63af7cac012ecd6e16a87d.svg";
export { ForwardRef as ReactComponent };